<template>
  <Viewer
      @inited="inited"
      ref="viewer"
  >
    <div class="grid grid-cols-12 gap-6 rtl:dir-rtl">
      <div class="col-start-1 col-end-13 md:col-end-5">
        <Card>
          <ul class="list space-y-8">
            <li class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="streamline:information-desk"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.firstName.label') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ completeProfile.firstName }}
                </div>
              </div>
            </li>
            <li class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="streamline:information-desk"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.lastName.label') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ completeProfile.lastName }}
                </div>
              </div>
            </li>
            <!-- end single list -->
            <li class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="heroicons:phone"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.phoneNumber.label') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ completeProfile.phoneNumber }}
                </div>
              </div>
            </li>
            <!-- end single list -->
            <li class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="heroicons:map"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.address.label') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ completeProfile.address }}
                </div>
              </div>
            </li>
            <!-- end single list -->
          </ul>
        </Card>
      </div>
      <div class="col-start-1 col-end-13 md:col-start-5 md:col-end-9">
        <Card>
          <div class="flex flex-col gap-6">
            <div class="flex flex-col text-2xl text-slate-600 dark:text-slate-300 gap-2">
              <div class="flex flex-row items-center gap-3">
                <Icon icon="heroicons:identification"/>
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 leading-[12px]"
                >
                  {{ $t('message.id_card.label') }}
                </div>
              </div>
              <div class="flex-1 rtl:text-right"
                   v-if="completeProfile.kycIdCard && getFileExtension(completeProfile.kycIdCard.link) === 'pdf'">
                <iframe :src="completeProfile.kycIdCard.link" class="h-full w-full"></iframe>
                <a :href="completeProfile.kycIdCard.link" target="_blank" class="text-sm text-primary-500 mt-2">
                  Download
                </a>
              </div>
              <div v-else class="flex-1 rtl:text-right" @click="show">
                <!--                    <Image
                                        :src="completeProfile.kycIdCard.link"
                                        :alt="$t('message.id_card.label')"
                                        imageClass="rounded-md border-4 border-slate-300"
                                    />-->
                <VueMagnifier v-if="completeProfile.kycIdCard" :src="completeProfile.kycIdCard.link"
                              class="rounded-md border-4 border-slate-300"/>
                <a v-if="completeProfile.kycIdCard" :href="completeProfile.kycIdCard.link" target="_blank"
                   class="text-sm text-primary-500 mt-2">
                  Download
                </a>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <div class="col-start-1 col-end-13 md:col-start-9">
        <Card>
          <div class="flex flex-col gap-6">
            <div class="flex flex-col text-2xl text-slate-600 dark:text-slate-300 gap-2">
              <div class="flex flex-row items-center gap-3">
                <Icon icon="uil:selfie"/>
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 leading-[12px]"
                >
                  {{ $t('message.selfie.label') }}
                </div>
              </div>
              <div class="flex-1 rtl:text-right"
                   v-if="completeProfile.kycSelfie && getFileExtension(completeProfile.kycSelfie.link) === 'pdf'">
                <iframe :src="completeProfile.kycSelfie.link" class="h-full w-full"></iframe>
                <a :href="completeProfile.kycSelfie.link" target="_blank" class="text-sm text-primary-500 mt-2">
                  Download
                </a>
              </div>
              <div v-else class="flex-1 rtl:text-right" @click="show">
                <!--                    <Image
                                        :src="completeProfile.kycSelfie.link"
                                        :alt="$t('message.selfie.label')"
                                        imageClass="rounded-md border-4 border-slate-300"
                                    />-->
                <VueMagnifier v-if="completeProfile.kycSelfie" :src="completeProfile.kycSelfie.link"
                              class="rounded-md border-4 border-slate-300"/>
                <a v-if="completeProfile.kycSelfie" :href="completeProfile.kycSelfie.link" target="_blank"
                   class="text-sm text-primary-500 mt-2">
                  Download
                </a>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </Viewer>
</template>
<script setup>
import Card from "@/components/Card/index.vue";
import 'viewerjs/dist/viewer.css';
import {component as Viewer} from 'v-viewer';
import VueMagnifier from '@websitebeaver/vue-magnifier'
import '@websitebeaver/vue-magnifier/styles.css'
import Icon from "@/components/Icon/index.vue";
import {useUserStore} from "@/stores/user.js";
import {useManagementStore} from "@/stores/management.js";
import {computed, ref} from "vue";
import Image from '@/components/Image/index.vue';
import {useEmailStore} from "@/stores/email.js";

const userStore = useUserStore();
const managementStore = useManagementStore();
let $viewer = null;
const inited = (viewer) => {
  $viewer = viewer;
};
const show = () => {
  if ($viewer) {
    $viewer.show(); // Opens the viewer at the specified index
  }
};
const store = useEmailStore();
const image = computed(() => {
  return store.image;
});

const getFileExtension = (url) => {
  // Use regex to extract the extension
  const matches = url.match(/\.([a-z0-9]+)$/i);
  return matches ? matches[1] : 'unknown';
};

const selectedApplicant = computed(() => managementStore.getSelectedApplicant);
const completeProfile = ref({});

async function getUserCompleteProfile() {
  const res = await userStore.action_getCompleteProfile3({id: selectedApplicant.value.id})
  if (res.result) {
    completeProfile.value = res.data
  }
}

getUserCompleteProfile()
</script>
<style scoped lang="scss">

</style>